  <app-odm-manage-option
    [selectedRange]="selectedRange"
    [options]="options"
    [activeReference]="activeOption"

    [references] = "references"
    [showOnPopUpStatus]="showOnPopUpStatus"
    (clickEditOptionButton)="onClickEditOptionButton($event)"
    (clickEditOptionValueButton)="onClickEditOptionValueButton($event)"
    (clickDeleteOptionValueButton)="onClickDeleteOptionValueButton($event)"
    (clickEditCategoryName)="onClickEditCategoryName($event)"
    (clickEditCategoryAssociation)="onClickEditCategoryAssociation($event)"
    (clickDeleteCategoryAssociation)="onClickDeleteCategoryAssociation($event)"
    (changeCategoryOrderEvent)="onChangeCategoryOrder($event)"
    (changeOptionOrderEvent)="onChangeOptionOrder($event)">
  </app-odm-manage-option>
